var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM12 4.35C7.77502 4.35 4.35 7.77502 4.35 12C4.35 16.225 7.77502 19.65 12 19.65C16.225 19.65 19.65 16.225 19.65 12C19.65 7.77502 16.225 4.35 12 4.35ZM10.6288 13.7242L15.1024 8.84389C15.3543 8.56908 15.7813 8.55052 16.0561 8.80242C16.3059 9.03143 16.344 9.40513 16.1596 9.67764L16.0976 9.75612L11.1476 15.1561C10.9115 15.4137 10.5236 15.445 10.2508 15.2444L10.1727 15.1773L7.9227 12.9273C7.6591 12.6637 7.6591 12.2363 7.9227 11.9727C8.16234 11.7331 8.53734 11.7113 8.80159 11.9074L8.8773 11.9727L10.6288 13.7242Z",
    fill: "#066C47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSuccess);
export default __webpack_public_path__ + "static/media/message-success.3c8baa666f23d62d037776e8126e0075.svg";
export { ForwardRef as ReactComponent };